<template>
<div class="ProfileContent">
    <div class="row margin-left-7Point2Perc margin-Top-5Perc">
        <div class="col-lg-3 margin-Top-1Point5Perc">
          <div class="">
            <img :src="getUserProfileImg()" alt="usericon2" class="center-crop border-radius" width="180px" height="180px" @error="assignDefaultImage($event)" id="userProfile">
            <img :src="imgediticon" alt="imgedit" height="20" width="20" class="image-zindex-1 cursor-pointer" v-on:click="openFileExplorerWindow"> 
            <input type="file" id="selectedFile" accept=".jpg, .jpeg, .png" style="display: none;" v-on:change="onFileSelected($event)"/>
          </div> 
        </div>
        <div class="col-lg-7">
          <div class="border-bottom padding font-size-17px">
              <div>
                <img :src=imgUserIcon alt="usericon" height="20" width="20"> &nbsp; &nbsp; {{getFullName}} 
              </div> 
          </div>
          <div class="border-bottom padding font-size-17px">
              <img :src=imgLocation alt="usericon" height="20" width="20"> &nbsp; &nbsp;{{getUserLocation}}
              <img :src="useredit" alt="useredit" height="40" width="15" class="pull-right cursor-pointer" @click="openUpdateLocationOverlay">
          </div>
          <div class="border-bottom padding font-size-17px">
              <img :src=imgPasw alt="imgPasw" height="20" width="20"> &nbsp; &nbsp;{{key}}
              <img :src="useredit" alt="useredit" height="40" width="15" class="pull-right cursor-pointer" @click="openUpdatePasswordOverlay">
          </div>
          <div class="border-bottom padding font-size-17px">
              <img :src=imgemail alt="imgemail" height="20" width="20"> &nbsp; &nbsp;{{getEmail}}
          </div>
          <div class="col-md-12 col-lg-12 margin-Top-10Perc" v-if="isUserGroupAdmin">
            <div class="col-md-4 col-lg-4">
            </div>
            <div class="col-md-4 col-lg-4">
              <button class="btn btn-primary btn-block unenroll-existing-button-BG black-font-color padding-6px-6px" @click="redirectToDashboard($event)">Back to Dashboard</button>
            </div>
            <div class="col-md-4 col-lg-4">
            </div>
          </div>
        </div>
        <div class="col-lg-2">
        </div>
      </div>
      <!-- Show Spinner -->
      <div class="animationload" v-show="showSpinner">
          <div class="osahanloading"></div>
      </div>
      <loader></loader>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>  
      <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixString" v-bind:postfixString="postString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="changeImage"></confirmation-alert>
      <update-user-location-overlay v-if="showUpdateLocationOverlay" @closeOverlay="closeOverlay"></update-user-location-overlay>
      <update-user-password-overlay v-if="showUpdatePasswordOverlay" @closeOverlay="closeOverlay" :showClose="showCloseIconOnPasswordChange"></update-user-password-overlay>
 </div>
</template>
<script>
import Loader from '@/components/dashboard/Loader'
import userIcon from '../../assets/images/usericon.svg'
import changepasswordicon from '../../assets/images/changepasswordicon.svg'
import locationicon from '../../assets/images/locationicon.svg'
import emailicon from '../../assets/images/emailicon.svg'
import usericon2 from '../../assets/images/usericon2.svg'
import editicon from '../../assets/images/profileimageediticon.svg'
import edit from '../../assets/images/edit.svg'
import server from '@/utils/server'
import UpdateUserPasswordOverlay from '@/components/profile/UpdateUserPasswordOverlay'
import UpdateUserLocationOverlay from '@/components/profile/UpdateUserLocationOverlay'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import AlertBox from '@/components/AlertOverlay'
import { participantService } from '@/server-util/participant-service'
import { constants } from '@/utils/constants'
export default {
  name: 'ProfileContent',
  created: function () {
    this.getQueryParam()
    this.setDefaultValues()
  },
  data: function () {
    return {
      userObj: {},
      userObjToPass: {
        UserId: '',
        FullName: '',
        UserLocation: '',
        Email: ''
      },
      key: 'Change Password',
      imgUserIcon: userIcon,
      imgPasw: changepasswordicon,
      imgLocation: locationicon,
      imgemail: emailicon,
      imgUserIcon2: usericon2,
      imgediticon: editicon,
      useredit: edit,
      imgUrl: '',
      showUpdatePasswordOverlay: false,
      showUpdateLocationOverlay: false,
      showConfirmationBox: false,
      prefixString: '',
      postString: '',
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      showCloseIconOnPasswordChange: true
    }
  },
  components: {
    'update-user-password-overlay': UpdateUserPasswordOverlay,
    'update-user-location-overlay': UpdateUserLocationOverlay,
    'confirmation-alert': ConfirmationOverlay,
    'alert-box': AlertBox,
    'loader': Loader
  },
  watch: {
    $route (to, from) {
      this.getQueryParam()
    }
  },
  methods: {
    redirectToDashboard: function ($event) {
      this.$router.push('/')
    },
    getQueryParam: function () {
      if (this.$route.query.OpenPopUp) {
        this.showUpdatePasswordOverlay = true
        this.showCloseIconOnPasswordChange = false
        this.$store.state.hightLightOptionExplictly = true
        this.$store.state.isComingFromLogin = false
        setTimeout(() => {
          this.$store.state.hightLightOptionExplictly = false
        }, 500)
      } else {
        this.showCloseIconOnPasswordChange = true
      }
      // console.log('this.$route.query.OpenPopUp: ' + this.$route.query.OpenPopUp)
    },
    changeImage (value) {
      this.showConfirmationBox = false
      if (value) {
        // AK: If user pressed OK then update it
        this.updateProfileImage()
      }
    },
    openFileExplorerWindow: function () {
      document.getElementById('selectedFile').click()
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    onFileSelected: function (event) {
      if (
        !this.checkProfileImageExtension(
          document.getElementById('selectedFile').value
        )
      ) {
        this.showAlertDialog = true
        this.errorMsg =
          'Please select .jpg, .jpeg or .png file.'
        event.target.value = ''
        return
      }
      this.showConfirmationBox = true
      this.prefixString = 'Are you sure you want to change'
      this.postString = ' profile image?'
      var selectedFile = event.target.files[0]
      var reader = new FileReader()
      var imgtag = document.getElementById('userProfile')
      imgtag.title = selectedFile.name
      reader.onload = function (event) {
        imgtag.src = event.target.result
      }
      reader.readAsDataURL(selectedFile)
    },
    checkProfileImageExtension: function (fileName) {
      var exts = ['.jpg', '.jpeg', '.png']
      return new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$').test(
        fileName
      )
    },
    updateShowConfirmationAlertFlag (value) {
      document.getElementById('userProfile').src = server.baseURL() + '/api/UserProfile/Picture?userId=' + this.userObjToPass.UserId
      // AK: Used when user pressed close button confirmation overlay
      this.showConfirmationBox = value
    },
    closeOverlay (value) {
      // AK: Used to close overlay
      this.showUpdatePasswordOverlay = value
      this.showUpdateLocationOverlay = value
      // AK: Enable Background Scrolling
      this.$store.state.isOverlayVisible = value
      // AK: Re-bind everything in order to see updated values
      this.setDefaultValues()
    },
    openUpdateLocationOverlay: function () {
      // AK: Disable background scrolling
      this.$store.state.isOverlayVisible = true
      this.showUpdateLocationOverlay = true
    },
    openUpdatePasswordOverlay: function () {
      // AK: Disable background scrolling
      this.$store.state.isOverlayVisible = true
      this.showUpdatePasswordOverlay = true
    },
    setDefaultValues: function () {
      this.userObj = this.$store.state.curr_user
      this.userObjToPass.FullName = this.userObj.FirstName + ' ' + this.userObj.LastName
      this.userObjToPass.UserLocation = this.userObj.UserLocation
      this.userObjToPass.Email = this.userObj.Email
      this.userObjToPass.UserId = this.userObj.UserId
    },
    getUserProfileImg () {
      this.imgUrl = server.baseURL() + '/api/UserProfile/Picture?userId=' + this.userObjToPass.UserId
      return this.imgUrl
    },
    assignDefaultImage: function (event) {
      document.getElementById('userProfile').src = usericon2
    },
    updateProfileImage: function () {
      var profileImg = document.getElementById('selectedFile').files[0]
      const formData = new FormData()
      formData.append('fileData', profileImg)
      var _this = this
      var storeObj = this.$store
      if (formData !== undefined || formData !== '' || formData !== undefined) {
        // AK: Start showing spinner
        // _this.showSpinner = true
        _this.$store.state.isLoading = true
        participantService
          .UpdateProfileImg(storeObj.state.access_token, formData)
          .then(
            responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                // document.getElementById('userProfile').src = server.baseURL() + '/api/UserProfile/Picture?userId=' + this.userObjToPass.UserId
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
              } else {
                // AK: Hide Spinner
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
                _this.showAlertDialog = true
                _this.errorMsg =
                  'Oops! Something went wrong. Please try again.'
              }
            },
            errorObj => {
              // AK: Hide Spinner
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              _this.showAlertDialog = true
              if (errorObj.response === undefined) {
                _this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                _this.errorMsg = errorObj.response.statusText
              }
            }
          )
      } else {
        console.log(
          'Selected FormData is NULL hence declined UPDATING USER PROFILE'
        )
      }
    }
  },
  computed: {
    getFullName: {
      get: function () {
        return this.userObjToPass.FullName
      },
      set: function (newValue) {
        this.userObjToPass.FullName = newValue
      }
    },
    getUserLocation: {
      get: function () {
        return this.userObjToPass.UserLocation
      },
      set: function (newValue) {
        this.userObjToPass.UserLocation = newValue
      }
    },
    getEmail: {
      get: function () {
        return this.userObjToPass.Email
      },
      set: function (newValue) {
        this.userObjToPass.Email = newValue
      }
    },
    isUserGroupAdmin: {
      get: function () {
        var userObj = this.$store.state.curr_user
        if (parseInt(userObj.AccountType) === parseInt(constants.UserAccountType.Group_Admin)) {
          return true
        } else {
          return false
        }
      }
    }
  }
}
</script>
<style scoped>
.center-crop {
  object-fit: cover;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.border-radius {
  border-radius: 50% !important;
}
.cursor-pointer {
  cursor: pointer;
}
.ProfileContent {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
}

.margin-left-4Perc{
  margin-left:4%;
}
.margin-left-5Perc{
  margin-left:5%;
}
.margin-left-7Point2Perc{
  margin-left:7.2%;
}
.margin-right-4Perc{
  margin-right:4%;
}

.float-right{
float: right;
}
.padding-right-0Perc{
  padding-left:0% !important;
}
.right-div{
  height:100%;
  float: right;
}
.admin-Panel-BG
{
  background-color: #f39c12;
}
.margin-Top-10Perc{
  margin-top:10%;
}
.margin-Top-15Perc{
  margin-top:15%;
}
.margin-Top-1Point5Perc
{
	margin-top: 1.5% !important; 
}
.margin-Top-3Perc
{
	margin-top: 3%;
}
.margin-Top-5Perc{
  margin-top: 5% !important;
}
.margin-Top-15Perc
{
	margin-top: 15%;
}
.margin-Top-1Perc
{
	margin-top: 1%;
}
.padding-Top-1Perc{
  padding-top: 1%;
}
.padding-Top-3Perc{
  padding-top: 3%;
}
.padding-Top-5Perc{
  padding-top: 5%;
}
.padding-Top-6Perc{
  padding-top: 6%;
}
.padding-Bottom-1Perc{
  padding-bottom: 1%;
}
.border-right
 {
   border-right: 1px solid #aaa !important;
 }
 .border-bottom{
   border-bottom: 1px solid #aaa;
 }
 .padding{
   padding:2%;
 }
 .font-size-15px {
  font-size: 15px;
}
 .font-size-17px {
  font-size: 17px;
}
.image-zindex-1 {
    position: absolute;
    left: 36px;
    top: 145px;
    z-index: 1;
}
.unenroll-existing-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color {
  color: #000;
}
.padding-6px-6px{
  padding: 6px 6px;
}
</style>


// WEBPACK FOOTER //
// src/components/profile/ProfileContent.vue